// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.UpdateStripeLandlordEmailAndPhoneWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber } from '@zg-rentals/ts-rent-payment-client';

import type {
  UpdateStripeLandlordEmailAndPhoneRequestDto,
  UpdateStripeLandlordEmailAndPhoneResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber_Args {
  postData: UpdateStripeLandlordEmailAndPhoneRequestDto;
}

export type UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber_Options =
  UseMutationOptions<
    UpdateStripeLandlordEmailAndPhoneResponseDto,
    unknown,
    UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber_Args
  >;

/**
 * Update a landlord's email and phone number in Stripe
 */
export const useUpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber = ({
  httpClient,
  ...options
}: Omit<
  UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber_Options,
  'mutationFn'
> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber_Args) =>
      UpdateStripeLandlordEmailAndPhoneWebApiHandler_updateStripeLandlordEmailAndPhoneNumber(args.postData, httpClient),
  });
};
